export default {
    props: {
        params: {
            type: Object,
            required: true
        }
    },

    methods: {
        async loadSettings(skipCache = false) {
            try {
                const { meetings } = await this.$services.settings.getSettings(this.params.event._id, skipCache ? 0 : 5000);
                const registry = await this.$services.settings.getRegistrySettings(this.params.event._id, 'meetings');
                this.settings = meetings;
                this.registry = registry;
            } catch (error) {
                console.error('[MeetingRequestsSettings] Could not load current settings', error);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('meetings.settings.error_loading').toString(),
                    type: 'error',
                    duration: 15000
                });
            }
        },

        async saveSettings(settings) {
            try {
                const updatedSettings = { ...this.settings, ...settings };
                console.debug('[MeetingRequestsSettings] Saving settings', updatedSettings);
                await this.$services.settings.saveSetting(this.params.event._id, 'meetings', updatedSettings);
                await this.loadSettings(true);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('meetings.messages.save_success').toString(),
                    type: 'success',
                    duration: 5000
                });
            } catch (error) {
                console.error('[Locations] Could not save settings', error);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('general.try_later').toString(),
                    type: 'error',
                    duration: 5000
                });
            }
        }
    }
};
